import { fetchData, getBlobData, postData } from "./apis";

const path = "/crm";

export const getCrmCustomerListApi = (value) => {
  let endPoint = `${path}/get-customer-list`;
  return postData(endPoint, value);
};

export const getDueSoonTasksApi = () => {
  let endPoint = `${path}/tasks/due-soon`;
  return postData(endPoint, {});
};

export const acknowledgeTaskReminderApi = (task_id) => {
  let endPoint = `${path}/tasks/reminder/acknowledge`;
  return postData(endPoint, { task_id });
};

export const getConversationApi = (value) => {
  let endPoint = `${path}/get-conversations`;
  return postData(endPoint, value);
};

export const customerStatusChangeApi = (value) => {
  let endPoint = `${path}/customer-status-change`;
  return postData(endPoint, value);
};

export const getUserWiseCustomerApi = (value) => {
  let endPoint = `${path}/get-user-wise-customer-report`;
  return postData(endPoint, value);
};

export const saveConversationApi = (value) => {
  let endPoint = `${path}/save-conversation`;
  return postData(endPoint, value);
};

export const getRejectedCustomerListApi = (value) => {
  let endPoint = `${path}/get-rejected-customer-list`;
  return postData(endPoint, value);
};

export const getApprovedCustomerListApi = (value) => {
  let endPoint = `${path}/get-approved-customer-list`;
  return postData(endPoint, value);
};

export const getPendingCustomerListApi = (value) => {
  let endPoint = `${path}/get-pending-customer-list`;
  return postData(endPoint, value);
};

export const leadActionApi = (value) => {
  let endPoint = `${path}/lead/action`;
  return postData(endPoint, value);
};
export const fetchLeadsApi = (value) => {
  let endPoint = `${path}/leads`;
  return postData(endPoint, value);
};

export const getLeadActivitiesApi = (value) => {
  let endPoint = `${path}/lead/activities`;
  return postData(endPoint, value);
};

export const fetchLeadStatusApi = (value) => {
  let endPoint = `${path}/lead-status`;
  return fetchData(endPoint, value);
};
export const fetchCrmFieldsApi = (params = {}) => {
  return fetchData(`${path}/settings/fields`, { params });
};
export const fetchCrmFieldDistinctValuesApi = (params = {}) => {
  return fetchData(`${path}/settings/fields/distinct-values`, { params });
};
export const fetchLeadSourceApi = (value) => {
  let endPoint = `${path}/lead-source`;
  return fetchData(endPoint, value);
};
export const addLeadStatusApi = (value) => {
  let endPoint = `${path}/lead-status/add`;
  return postData(endPoint, value);
};
export const updateLeadStatusApi = (data) =>
  postData("/crm/lead-status/update", data);

export const deleteLeadStatusApi = (data) =>
  postData("/crm/lead-status/delete", data);

export const fetchLeadPurposeApi = (value) => {
  let endPoint = `${path}/lead-purpose`;
  return fetchData(endPoint, value);
};
export const addLeadPurposeApi = (value) => {
  let endPoint = `${path}/lead-purpose/add`;
  return postData(endPoint, value);
};
export const updateLeadPurposeApi = (data) =>
  postData("/crm/lead-purpose/update", data);

export const deleteLeadPurposeApi = (data) =>
  postData("/crm/lead-purpose/delete", data);
export const addLeadSourceApi = (value) => {
  let endPoint = `${path}/lead-source/add`;
  return postData(endPoint, value);
};
export const updateLeadSourceApi = (data) =>
  postData("/crm/lead-source/update", data);

export const deleteLeadSourceApi = (data) =>
  postData("/crm/lead-source/delete", data);

export const fetchTeamsApi = () => fetchData(`${path}/teams`);
export const createTeamApi = (data) => postData(`${path}/teams/add`, data);
export const updateTeamApi = (data) => postData(`${path}/teams/update`, data);
export const deleteTeamApi = (data) => postData(`${path}/teams/delete`, data);
export const fetchMyTeammatesApi = () => fetchData(`${path}/teams/my-teammates`);
export const updateLeadMetaApi = (value) => {
  let endPoint = `${path}/lead/update-meta`;
  return postData(endPoint, value);
};
export const bulkUpdateLeadsApi = (value) => {
  let endPoint = `${path}/leads/bulk-update`;
  return postData(endPoint, value);
};
export const callFeedbackApi = (data) => {
  return postData("/crm/call-feedback", data);
};
export const fetchDealTypeApi = (value) => {
  let endPoint = `${path}/deal-type`;
  return fetchData(endPoint, value);
};

export const addDealTypeApi = (data) => postData("/crm/deal-type/add", data);

export const updateDealTypeApi = (data) =>
  postData("/crm/deal-type/update", data);

export const deleteDealTypeApi = (data) =>
  postData("/crm/deal-type/delete", data);

export const fetchTaskTypeApi = () => fetchData(`${path}/task-type`);

export const addTaskTypeApi = (data) => postData("/crm/task-type/add", data);

export const updateTaskTypeApi = (data) => postData("/crm/task-type/update", data);

export const deleteTaskTypeApi = (data) => postData("/crm/task-type/delete", data);

export const createFields = (value) => {
  let endPoint = `${path}/settings/fields/create`;
  return postData(endPoint, value);
};

export const updateFieldApi = (value) => postData(`${path}/settings/fields/update`, value);

export const deleteFieldApi = (value) => postData(`${path}/settings/fields/delete`, value);
// export const fetchCustomFieldsApi = (params = {}) => {
//   return fetchData(`${path}/settings/fields`, { params });
// };

export const createLeadApi = (value) => {
  let endPoint = `${path}/leads/create`;
  return postData(endPoint, value);
};

export const updateLeadApi = (data) => postData("/crm/leads/update", data);

// Bulk import: at most 100 rows per request (the server enforces it).
// `import_run_id` groups every chunk of one file upload under one history
// entry; `assigned_to` is only honoured for admins; `auto_create_missing`
// lets the server self-heal if a lookup value vanished since validate ran.
export const importLeadsApi = (rows, { assigned_to, import_run_id, auto_create_missing, file_name, total_rows } = {}) =>
  postData(`${path}/leads/import`, { rows, assigned_to, import_run_id, auto_create_missing, file_name, total_rows });

// Pre-flight: checks the WHOLE file's status/source/purpose/custom-field
// values against this branch's master lists before any lead is created.
export const validateImportApi = (rows, { auto_create_missing } = {}) =>
  postData(`${path}/leads/import/validate`, { rows, auto_create_missing });

export const fetchLeadImportHistoryApi = (params = {}) =>
  fetchData(`${path}/leads/import/history`, { params });

export const fetchLeadImportHistoryRowsApi = (runId) =>
  fetchData(`${path}/leads/import/history/${runId}/rows`);

// Admin only (enforced server-side) -- who exported leads and when.
export const fetchLeadExportHistoryApi = (params = {}) =>
  fetchData(`${path}/leads/export/history`, { params });

// Admin only (enforced server-side) -- cross-record "who changed what" log
// for lead/deal field edits and lead deletions.
export const fetchCrmAuditLogApi = (params = {}) =>
  fetchData(`${path}/audit-log`, { params });

// Admin only (enforced server-side). `filters` is the Leads list's own filter object.
export const exportLeadsApi = (filters, format = "xlsx") =>
  postData(`${path}/leads/export`, { ...filters, format }, { responseType: "blob" });

export const checkLeadPhoneApi = (payload) =>
  postData("/crm/leads/check-phone", payload);

// Admin only (enforced server-side). Soft-deletes the lead.
export const deleteLeadApi = (id) => postData("/crm/leads/delete", { id });

export const updateLeadCustomFieldApi = (data) =>
  postData("/crm/lead/update-custom-field", data);

export const createDealApi = (value) => {
  let endPoint = `${path}/deals/create`;
  return postData(endPoint, value);
};
export const updateDealMetaApi = (value) => {
  let endPoint = `${path}/deals/update-meta`;
  return postData(endPoint, value);
};

export const assignLeadApi = (value) => {
  let endPoint = `${path}/leads/assign`;
  return postData(endPoint, value);
};
export const fetchDealsApi = (value) => {
  let endPoint = `${path}/deals`;
  return postData(endPoint, value);
};
export const updateDealStageApi = (value) => {
  let endPoint = `${path}/deals/update-stage`;
  return postData(endPoint, value);
};
export const getDealActivitiesApi = (value) => {
  return postData(`${path}/deal/activities`, value);
};

export const addDealActivityApi = (value) => {
  return postData(`${path}/deal/activity/add`, value);
};
export const fetchTodayTasksApi = (value) => {
  return postData(`${path}/tasks/today`, value);
};
export const getPerformanceApi = (value) => {
  let endPoint = `${path}/performance`;
  return postData(endPoint, value);
};
export const getPipelineStatsApi = (value) => {
  let endPoint = `${path}/pipeline-stats`;
  return fetchData(endPoint, value);
};

export const completeTaskApi = (value) => {
  return postData(`${path}/tasks/complete`, value);
};

export const snoozeTaskApi = (data) => postData(`${path}/tasks/snooze`, data);

export const rescheduleTaskApi = (data) =>
  postData(`${path}/tasks/reschedule`, data);

export const fetchTasksApi = (value) => {
  return postData(`${path}/tasks`, value);
};
export const createTasksApi = (value) => {
  return postData(`${path}/tasks/create`, value);
};
export const getTaskDetailsApi = (data) =>
  postData(`${path}/task/details`, data);

export const updateTaskApi = (data) => postData(`${path}/task/update`, data);

export const getTaskActivitiesApi = (data) =>
  postData(`${path}/task/activities`, data);

export const addTaskActivityApi = (data) =>
  postData(`${path}/task/activity/add`, data);

export const getCrmNotificationsApi = (value) => {
  return postData(`${path}/notifications`, value);
};

export const getCrmDashboardApi = (payload = {}) =>
  postData("/crm/dashboard", payload);

export const getMetaConnectUrlApi = (value) =>
  fetchData("/crm/meta/connect-url", value);

export const fetchMetaIntegrationsApi = (value) =>
  fetchData("/crm/meta/integrations", value);

export const disconnectMetaIntegrationApi = (data) =>
  postData("/crm/meta/disconnect", data);

export const saveMetaFormsApi = (data) =>
  postData("/crm/meta/forms/save", data);

export const fetchMetaPageFormsApi = (integrationId) =>
  fetchData(`/crm/meta/forms/${integrationId}`);

export const fetchConnectedMetaFormsApi = (data) =>
  fetchData("/crm/meta/connected-forms", data);

export const updateMetaFormStatusApi = (data) =>
  postData("/crm/meta/forms/status", data);

export const fetchMetaFormConfigurationApi = (formId) =>
  fetchData(`/crm/meta/forms/config/${formId}`);

export const saveMetaFormConfigurationApi = (payload) =>
  postData("/crm/meta/forms/config/save", payload);

// CRM website apis integration starts
export const getCrmApiKeysApi = () => fetchData("/crm/api-keys");

export const generateCrmApiKeyApi = (payload) =>
  postData("/crm/api-keys/create", payload);

export const revokeCrmApiKeyApi = (id) =>
  postData("/crm/api-keys/revoke", { id });

export const updateCrmApiKeyPermissionsApi = (payload) =>
  postData("/crm/api-keys/permissions", payload);

export const getCrmApiRequestLogsApi = (payload = {}) =>
  postData("/crm/api-request-logs", payload);


// CRM website apis integration ends

// CRM Reports (catalog) -- conversion/employee-activity/tasks/deals reports
// and the generic export, alongside the existing /crm/reports/leads above.
export const fetchConversionReportApi = (payload) =>
  postData(`${path}/reports/conversion`, payload);

export const fetchEmployeeActivityReportApi = (payload) =>
  postData(`${path}/reports/employee-activity`, payload);

export const fetchTaskReportApi = (payload) =>
  postData(`${path}/reports/tasks-summary`, payload);

export const fetchDealPerformanceReportApi = (payload) =>
  postData(`${path}/reports/deals-performance`, payload);

export const exportCrmReportApi = (reportType, filters, format = "xlsx") =>
  postData(`${path}/reports/export`, { report_type: reportType, filters, format }, { responseType: "blob" });

export const fetchReportExportHistoryApi = (params = {}) =>
  fetchData(`${path}/reports/export/history`, { params });